module.exports = __webpack_public_path__ + "static/media/push.25944edf.mp3";